import {
  dispatchAction,
  OrderResponseFromStatusV2,
} from 'business/shared/infra';
import type { DetailState, OrderId } from 'shared/domain';
import { storeAuditAction, storeAuditSelector } from '../store';

function hasDefectRateReport(detail: DetailState) {
  if (detail == null) {
    return false;
  }
  return detail?.products.some(x => x?.has_defect_rate_report);
}

function getOrderAudit(orderId: OrderId) {
  return storeAuditSelector.selectById(orderId);
}

function addCheckedOrder(orderId: OrderId, isDefectsChecked: boolean) {
  dispatchAction(
    storeAuditAction.upsert({ orderId, isAllChecked: isDefectsChecked }),
  );
}

function trackingUpdate(orderId: OrderId) {
  dispatchAction(storeAuditAction.trackingUpdate(orderId));
}

function syncWithV2Orders(orders: OrderResponseFromStatusV2[]) {
  dispatchAction(storeAuditAction.syncWithOrders(orders));
}

export const storeAuditService = {
  hasDefectRateReport,
  getOrderAudit,
  addCheckedOrder,
  trackingUpdate,
  syncWithV2Orders,
} as const;
